/* ELAGIA-A11Y — доступность слайдеров Swiper (тема Purity / Vavilon).
   Тема инициализирует Swiper без модуля a11y, поэтому:
   1) слайды вне видимой области (нет .swiper-slide-visible) получают aria-hidden + inert —
      Tab больше не ходит по ссылкам скрытых карточек (WCAG 2.4.3 Focus Order);
   2) контейнер слайдера = role="region" + aria-roledescription="carousel" + aria-label;
   3) перед слайдером — skip-link «Skip carousel» (WCAG 2.4.1 Bypass Blocks);
   4) стрелки получают aria-disabled по классу swiper-button-disabled.
   Ничего в теме не переписываем — только наблюдаем за DOM. */
(function () {
  'use strict';
  if (!('inert' in HTMLElement.prototype)) return; // старые браузеры — без изменений

  var scheduled = new Set();
  var usedLabels = {};
  var raf = null;

  function labelFor(sw) {
    if (sw.getAttribute('aria-label')) return sw.getAttribute('aria-label');
    if (sw.closest('media-gallery, quick-view-gallery, .product__media-gallery')) return 'Product images';
    var sec = sw.closest('.shopify-section, section');
    var h = sec && sec.querySelector('h1, h2, h3, .section-heading, .title');
    var t = h && h.textContent.trim().replace(/\s+/g, ' ');
    return t ? t + ' carousel' : 'Carousel';
  }

  function setupRegion(sw) {
    if (sw.hasAttribute('data-a11y-region')) return;
    sw.setAttribute('data-a11y-region', '');
    if (sw.querySelectorAll('.swiper-slide').length < 2) return; // один слайд — это не карусель
    if (!sw.getAttribute('role')) sw.setAttribute('role', 'region');
    if (!sw.getAttribute('aria-roledescription')) sw.setAttribute('aria-roledescription', 'carousel');
    if (!sw.getAttribute('aria-label')) {
      // подписи регионов должны быть уникальны (axe landmark-unique): второй «Product images» → «Product images 2»
      var base = labelFor(sw), label = base, n = 2;
      while (usedLabels[label]) label = base + ' ' + (n++);
      usedLabels[label] = true;
      sw.setAttribute('aria-label', label);
    }

    // skip-link: только для слайдеров с хотя бы 2 слайдами и ссылками внутри
    var slides = sw.querySelectorAll('.swiper-slide');
    if (slides.length < 2 || !sw.querySelector('a, button')) return;
    var id = 'after-' + (sw.id || 'swiper-' + Math.random().toString(36).slice(2, 8));
    var target = document.createElement('span');
    target.id = id; target.tabIndex = -1; target.className = 'elagia-skip-target';
    sw.insertAdjacentElement('afterend', target);
    var link = document.createElement('a');
    link.href = '#' + id;
    link.className = 'elagia-skip-carousel skip-to-content-link button visually-hidden';
    link.textContent = 'Skip carousel';
    link.addEventListener('click', function (e) { e.preventDefault(); target.focus(); });
    sw.insertAdjacentElement('afterbegin', link);
  }

  function sync(sw) {
    var wrapper = sw.querySelector(':scope > .swiper-wrapper');
    if (!wrapper) return;
    var slides = wrapper.children;
    var anyVisible = false, i, s;
    for (i = 0; i < slides.length; i++) if (slides[i].classList.contains('swiper-slide-visible')) { anyVisible = true; break; }
    // если тема не отмечает видимость (watchSlidesVisibility выкл.) — ничего не прячем
    for (i = 0; i < slides.length; i++) {
      s = slides[i];
      if (!s.classList.contains('swiper-slide')) continue;
      if (s.tagName === 'A' && s.getAttribute('role') === 'group') s.removeAttribute('role'); // role=group недопустим на ссылке
      var hidden = anyVisible && !s.classList.contains('swiper-slide-visible');
      if (hidden) {
        if (s.getAttribute('aria-hidden') !== 'true') s.setAttribute('aria-hidden', 'true');
        if (!s.inert) s.inert = true;
      } else {
        if (s.hasAttribute('aria-hidden')) s.removeAttribute('aria-hidden');
        if (s.inert) s.inert = false;
      }
    }
    var arrows = sw.querySelectorAll(':scope > .swiper-actions .swiper-arrow, :scope .swiper-arrow');
    for (i = 0; i < arrows.length; i++) {
      var a = arrows[i];
      var dis = a.classList.contains('swiper-button-disabled') || a.classList.contains('swiper-button-lock');
      a.setAttribute('aria-disabled', dis ? 'true' : 'false');
      if (a.tagName !== 'BUTTON' && !a.hasAttribute('tabindex')) { // на случай стрелок из других сниппетов
        a.setAttribute('role', 'button'); a.tabIndex = 0;
        if (!a.getAttribute('aria-label')) a.setAttribute('aria-label', a.classList.contains('swiper-button-prev') ? 'Previous slide' : 'Next slide');
        a.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); } });
      }
    }
  }

  function flush() {
    raf = null;
    scheduled.forEach(function (sw) { if (sw.isConnected) { setupRegion(sw); sync(sw); } });
    scheduled.clear();
  }
  function schedule(sw) { scheduled.add(sw); if (!raf) raf = requestAnimationFrame(flush); }

  // Картинки-постеры внутри <video> карточек товара (video-product) рендерятся без alt (axe image-alt, critical).
  // Это дубликат обложки товара, название уже есть в ссылке карточки — помечаем как декоративные.
  function fixVideoImgs(root) {
    var imgs = (root.querySelectorAll ? root.querySelectorAll('video-product img:not([alt]), video img:not([alt])') : []);
    for (var i = 0; i < imgs.length; i++) imgs[i].setAttribute('alt', '');
  }

  function scan(root) {
    fixVideoImgs(root);
    var list = (root.matches && root.matches('.swiper')) ? [root] : [];
    list = list.concat(Array.prototype.slice.call(root.querySelectorAll ? root.querySelectorAll('.swiper') : []));
    list.forEach(function (sw) { if (sw.classList.contains('swiper-initialized') || sw.querySelector('.swiper-slide-visible')) schedule(sw); });
  }

  var mo = new MutationObserver(function (muts) {
    for (var k = 0; k < muts.length; k++) {
      var m = muts[k];
      if (m.type === 'attributes') {
        var t = m.target;
        if (t.classList && (t.classList.contains('swiper-slide') || t.classList.contains('swiper') || t.classList.contains('swiper-arrow'))) {
          var sw = t.closest('.swiper'); if (sw) schedule(sw);
        }
      } else if (m.type === 'childList') {
        for (var j = 0; j < m.addedNodes.length; j++) if (m.addedNodes[j].nodeType === 1) scan(m.addedNodes[j]);
      }
    }
  });

  function start() {
    scan(document.body);
    mo.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    // Swiper мог проставить классы до подписки — контрольный проход
    setTimeout(function () { scan(document.body); }, 1500);
    setTimeout(function () { fixVideoImgs(document.body); }, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ELAGIA-A11Y v2 (27.08.2026) — дроверы/модалки темы (cart-drawer, quickview-drawer и др. .active-modal-js):
   1) Escape закрывает активный дровер (тема не слушает Esc) — WCAG 2.1.1/2.1.2;
   2) фокус: если через 600 мс после modal:opened фокус не внутри модалки (его перехватил сторонний
      попап или анимация) — возвращаем его в .modal-inner[role=dialog]; при закрытии — на кнопку-триггер;
   3) статусы корзины озвучиваются через собственный role=status (WCAG 4.1.3): «Added to cart. Cart: N items»;
   4) неактивные шаблоны дроверов (.content-hidden) получают aria-hidden, чтобы их заглушки
      («Product title») не читались скринридером. */
(function () {
  'use strict';
  var SEL = '.active-modal-js';
  var lastTrigger = null;

  function activeModal() {
    var list = document.querySelectorAll(SEL + '.active');
    return list.length ? list[list.length - 1] : null;
  }
  function inner(m) { return m && (m.querySelector('.modal-inner[role="dialog"]') || m.querySelector('.modal-inner')); }
  function closeBtn(m) { return m && m.querySelector('.modal-button-close, .modal__close, button[is="button-close-model"], [aria-label="Close"]'); }

  // статус-регион вне перерисовываемых частей дровера
  var status = document.createElement('div');
  status.id = 'elagia-a11y-status';
  status.className = 'visually-hidden';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.setAttribute('aria-atomic', 'true');
  var lastText = '', lastAt = 0;
  function announce(text) {
    var now = Date.now();
    // не дублировать одно и то же объявление: «Cart updated» от счётчика и «Added to cart»
    // от события темы приходили с разницей ~1 с и читались дважды (WCAG 4.1.3).
    if (text === lastText && now - lastAt < 2500) return;
    lastText = text; lastAt = now;
    status.textContent = '';
    setTimeout(function () { status.textContent = text; }, 50);
  }
  // окно «идёт добавление в корзину»: клик по Add to cart / quick add ставит метку,
  // чтобы изменение счётчика озвучилось как «Added to cart», а не как «Cart updated».
  var addPendingAt = 0;
  function addPending() { return Date.now() - addPendingAt < 6000; }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    // +/- и удаление внутри дровера закрывают окно «идёт добавление»: иначе смена количества
    // через 2 с после Add to cart читалась бы как «Added to cart»
    if (t.closest('.quantity__button, [name="plus"], [name="minus"], .cart-remove-button, [id^="Remove"]')) { addPendingAt = 0; return; }
    if (t.closest('button[name="add"], .btn__quick-add, .btn__quick-shop, [data-add-to-cart]')) addPendingAt = Date.now();
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && String(f.action).indexOf('/cart/add') !== -1) addPendingAt = Date.now();
  }, true);
  function cartCount() {
    var c = document.querySelector('cart-icon-bubble .cart-count .count, .cart-count .count');
    if (!c) return document.querySelector('.cart-count') ? 0 : null; // пустая корзина рендерится без .count
    var n = parseInt(c.textContent, 10);
    return isNaN(n) ? null : n;
  }
  function countText(n) { return n === null ? '' : ' Cart: ' + n + (n === 1 ? ' item.' : ' items.'); }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || e.defaultPrevented) return;
    var m = activeModal(); if (!m) return;
    var btn = closeBtn(m);
    if (btn) { e.preventDefault(); btn.click(); }
  }, true);

  document.addEventListener('focusin', function (e) {
    if (!activeModal()) lastTrigger = e.target;
  }, true);

  document.addEventListener('modal:opened', function () {
    var trigger = document.activeElement && !document.activeElement.closest(SEL) ? document.activeElement : lastTrigger;
    setTimeout(function () {
      var m = activeModal(); if (!m) return;
      m.__a11yTrigger = trigger;
      var a = document.activeElement;
      if (!a || !m.contains(a)) { var el = inner(m); if (el) el.focus({ preventScroll: true }); }
    }, 600);
  });

  document.addEventListener('modal:closed', function (e) {
    var m = e.detail && e.detail.modal;
    var t = m && m.__a11yTrigger;
    setTimeout(function () {
      if (activeModal()) return; // открыта другая модалка
      var a = document.activeElement;
      if (t && t.isConnected && (!a || a === document.body || (m && m.contains(a)))) t.focus({ preventScroll: true });
    }, 50);
  });

  document.addEventListener('nextsky:cart:added', function () {
    addPendingAt = Date.now();
    setTimeout(function () { announce('Added to cart.' + countText(cartCount())); }, 900);
  });

  // изменения количества/удаление: следим за счётчиком корзины
  var lastCount = null, pending = null;
  function watchCount() {
    var n = cartCount();
    if (n === null || n === lastCount) return;
    var prev = lastCount; lastCount = n;
    if (prev === null) return; // первичная инициализация
    clearTimeout(pending);
    pending = setTimeout(function () {
      if (!document.querySelector('cart-drawer.active') && !document.body.classList.contains('template-cart')) return;
      if (addPending()) { announce('Added to cart.' + countText(n)); return; }
      if (n === 0) { announce('Your cart is empty.'); return; }
      announce((prev !== null && n < prev ? 'Item removed.' : 'Cart updated.') + countText(n));
    }, 400);
  }

  // скрытые шаблоны дроверов — вне дерева доступности
  function syncHidden() {
    var all = document.querySelectorAll(SEL);
    for (var i = 0; i < all.length; i++) {
      var m = all[i];
      var hide = m.classList.contains('content-hidden') && !m.classList.contains('active');
      if (hide) { if (m.getAttribute('aria-hidden') !== 'true') m.setAttribute('aria-hidden', 'true'); }
      else if (m.hasAttribute('aria-hidden')) m.removeAttribute('aria-hidden');
    }
  }

  function start() {
    document.body.appendChild(status);
    lastCount = cartCount();
    syncHidden();
    new MutationObserver(function (muts) {
      var cls = false;
      for (var i = 0; i < muts.length; i++) if (muts[i].type === 'attributes') { cls = true; break; }
      if (cls) syncHidden();
      watchCount();
    }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ELAGIA-A11Y v3 (27.08.2026) — модальный диалог корзины / quick view по WAI-ARIA APG.
   Что было (замер headless на живом PDP): после Add to cart фокус входит в .modal-inner[role=dialog],
   но Tab x20 уходил из дровера 20/20 раз — в cookie-баннер, шапку и меню; через ~4 с фокус
   перехватывал попап Klaviyo. Штатный NextSkyTheme.trapFocus вычисляет первый/последний
   фокусируемый элемент ОДИН раз при открытии, а дровер перерисовывается через Sections API —
   ссылки протухают и ловушка перестаёт работать.

   1) фон под открытым дровером получает inert (WCAG 1.3.2 / 2.4.3): ни Tab, ни скринридер,
      ни автофокус сторонних попапов не уводят из диалога; снимается сразу после закрытия;
   2) собственный focus trap: Tab/Shift+Tab закольцованы по живому списку элементов;
   3) фокус заводится внутрь диалога после открытия и после каждой перерисовки содержимого;
   4) quick-add кнопки получают имя товара (WCAG 4.1.2: «Add to cart» → «Add to cart: Sia Bordeaux…»),
      <summary> фильтров — aria-expanded по состоянию <details open>;
   5) label[aria-label] у свотчей цвета: aria-label на <label> запрещён (axe aria-prohibited-attr,
      serious) — имя переносится в .visually-hidden текст внутри label. */
(function () {
  'use strict';
  var SEL = '.active-modal-js';
  var FOCUSABLE = 'a[href],area[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,iframe,object,[tabindex]:not([tabindex^="-"]),[contenteditable="true"]';
  var SKIP_TAG = { SCRIPT: 1, STYLE: 1, LINK: 1, TEMPLATE: 1, NOSCRIPT: 1 };

  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  // ловушку и inert включаем только там, где у пользователя гарантированно есть выход:
  // кнопка Close или кликабельный оверлей (плюс Esc из блока v2).
  function trappable(m) {
    return !!(m.querySelector('.modal-button-close, .modal__close, [aria-label="Close"], modal-overlay, .modal-overlay'));
  }
  function activeModal() {
    var list = document.querySelectorAll(SEL + '.active');
    for (var i = list.length - 1; i >= 0; i--) if (visible(list[i]) && trappable(list[i])) return list[i];
    return null;
  }
  function dialogOf(m) { return m.querySelector('.modal-inner[role="dialog"]') || m.querySelector('.modal-inner') || m; }
  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
      return visible(el) && el.tabIndex >= 0 && !el.closest('[inert],[aria-hidden="true"]');
    });
  }

  // --- 1. фон inert ------------------------------------------------------
  // Идемпотентно: помечаем только своим data-elagia-inert, чужой inert не трогаем и не снимаем.
  function syncInert() {
    var m = activeModal(), kids = document.body.children, i, k, want, have;
    for (i = 0; i < kids.length; i++) {
      k = kids[i];
      if (SKIP_TAG[k.tagName] || k.id === 'elagia-a11y-status') continue;
      want = !!m && k !== m && !k.contains(m);
      have = k.hasAttribute('data-elagia-inert');
      if (want && !have) {
        if (k.hasAttribute('inert')) continue; // чужой inert — оставляем как есть
        k.setAttribute('inert', ''); k.setAttribute('data-elagia-inert', '');
      } else if (!want && have) {
        k.removeAttribute('inert'); k.removeAttribute('data-elagia-inert');
      }
    }
  }

  // --- 2. focus trap -----------------------------------------------------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || e.defaultPrevented) return;
    var m = activeModal(); if (!m) return;
    var d = dialogOf(m), list = focusables(d), a = document.activeElement;
    if (!list.length) { e.preventDefault(); e.stopPropagation(); d.focus({ preventScroll: true }); return; }
    var first = list[0], last = list[list.length - 1];
    if (!(a === d || d.contains(a))) { e.preventDefault(); e.stopPropagation(); (e.shiftKey ? last : first).focus({ preventScroll: true }); return; }
    if (!e.shiftKey && a === last) { e.preventDefault(); e.stopPropagation(); first.focus({ preventScroll: true }); }
    else if (e.shiftKey && (a === first || a === d)) { e.preventDefault(); e.stopPropagation(); last.focus({ preventScroll: true }); }
  }, true);

  // страховка: если фокус всё же оказался снаружи (autofocus стороннего попапа) — возвращаем
  var guarding = false;
  document.addEventListener('focusin', function (e) {
    var m = activeModal(); if (!m) return;
    var d = dialogOf(m);
    if (e.target === d || d.contains(e.target)) return;
    if (guarding) return;
    guarding = true; setTimeout(function () { guarding = false; }, 150);
    var list = focusables(d);
    (list[0] || d).focus({ preventScroll: true });
  }, true);

  // --- 3. вход фокуса в диалог -------------------------------------------
  function focusIntoDialog() {
    var m = activeModal(); if (!m) return;
    var d = dialogOf(m), a = document.activeElement;
    if (a === d || d.contains(a)) return;
    if (!d.hasAttribute('tabindex')) d.setAttribute('tabindex', '-1');
    d.focus({ preventScroll: true });
    if (document.activeElement !== d) { var l = focusables(d); if (l.length) l[0].focus({ preventScroll: true }); }
  }
  document.addEventListener('modal:opened', function () {
    [80, 250, 600, 1100, 1800].forEach(function (t) {
      setTimeout(function () { syncInert(); focusIntoDialog(); }, t);
    });
  });
  document.addEventListener('modal:closed', function () {
    [0, 150, 700, 1400].forEach(function (t) { setTimeout(syncInert, t); });
  });

  // --- 4. имена quick-add / состояние фильтров ---------------------------
  function cardTitle(btn) {
    var card = btn.closest('.product-item, .product-card, .card-product, [data-product-id], .swiper-slide');
    if (!card) return '';
    var t = card.querySelector('.product-item__name, .product__name, .card__heading, .product-item__title');
    return t ? t.textContent.trim().replace(/\s+/g, ' ').slice(0, 80) : '';
  }
  function nameQuickAdd(root) {
    var btns = root.querySelectorAll ? root.querySelectorAll('.btn__quick-add:not([data-a11y-named]), .btn__quick-shop:not([data-a11y-named]), product-form.quick-add button[name="add"]:not([data-a11y-named])') : [];
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], title = cardTitle(b);
      if (!title) continue;
      b.setAttribute('data-a11y-named', '');
      var base = (b.getAttribute('aria-label') || b.textContent.trim().replace(/\s+/g, ' ') || 'Add to cart').slice(0, 40);
      if (base.indexOf(title) === -1) b.setAttribute('aria-label', base + ': ' + title);
    }
  }
  function syncSummaries(root) {
    var sums = root.querySelectorAll ? root.querySelectorAll('details > summary') : [];
    for (var i = 0; i < sums.length; i++) {
      var s = sums[i], open = s.parentElement.hasAttribute('open') ? 'true' : 'false';
      if (s.getAttribute('aria-expanded') !== open) s.setAttribute('aria-expanded', open);
    }
  }
  // --- 5. aria-label на <label> запрещён ---------------------------------
  function fixLabelAria(root) {
    var labels = root.querySelectorAll ? root.querySelectorAll('label[aria-label]') : [];
    for (var i = 0; i < labels.length; i++) {
      var l = labels[i];
      if (l.getAttribute('role')) continue; // с ролью aria-label допустим
      var txt = (l.getAttribute('aria-label') || '').trim();
      l.removeAttribute('aria-label');
      if (!txt) continue;
      if (l.textContent.replace(/\s+/g, ' ').trim() === txt) continue; // текст уже есть
      var sp = document.createElement('span');
      sp.className = 'visually-hidden';
      sp.textContent = txt;
      l.appendChild(sp);
    }
  }

  function pass(root) { nameQuickAdd(root); syncSummaries(root); fixLabelAria(root); }

  var raf = null, lastPass = 0, passTimer = null;
  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      syncInert(); // дёшево: ~20 прямых детей body
      // перерисовка дровера через Sections API уносит фокус в body — возвращаем
      var m = activeModal();
      if (m && (document.activeElement === document.body || !document.activeElement)) focusIntoDialog();
      // полный проход по документу — не чаще раза в 400 мс (Swiper дёргает классы каждый кадр)
      var now = Date.now();
      if (now - lastPass > 400) { lastPass = now; pass(document); }
      else if (!passTimer) passTimer = setTimeout(function () { passTimer = null; lastPass = Date.now(); pass(document); }, 400);
    });
  }

  function start() {
    syncInert(); pass(document);
    new MutationObserver(schedule).observe(document.documentElement, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open']
    });
    setTimeout(function () { pass(document); }, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ───────────────────────────────────────────────────────────────────────────
   Блок v3 (15.09.2026) — WCAG 2.2.2 Pause, Stop, Hide (уровень A)

   На главной 4 автозапускающихся зацикленных видео без единого способа
   остановить движение. Скрипт NextSky (nextsky-a11y-media.js) вешает на них
   aria-hidden="true" — это критерий НЕ закрывает: 2.2.2 про видимое движение
   и защищает людей с вестибулярными нарушениями и расстройствами внимания,
   которые экран видят. Нужен именно контрол.

   Здесь: кнопка паузы 44x44 на каждое autoplay-видео, у которого контрола нет.
   Чужой .ns-media-toggle уважаем и второй кнопки не добавляем.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var MARK = 'data-elagia-vpause';

  function hasControl(v) {
    if (v.controls) return true;
    var host = v.closest('[class*="media"],[class*="video"],figure,picture') || v.parentElement;
    for (var i = 0; i < 3 && host; i++) {
      if (host.querySelector('.ns-media-toggle, [' + MARK + ']')) return true;
      host = host.parentElement;
    }
    return false;
  }

  // Подпись должна отличать кнопки друг от друга: в UGC-галерее их семь подряд,
  // и семь одинаковых «Play FOLLOW US» для скринридера бесполезны.
  function label(v, paused) {
    var near = v.closest('[class*="section"],section');
    var h = near && near.querySelector('h1,h2,h3');
    var what = (h && h.textContent.trim().slice(0, 34)) || 'background video';
    var all = near ? near.querySelectorAll('video[autoplay]') : [];
    var pos = '';
    if (all.length > 1) {
      for (var i = 0; i < all.length; i++) {
        if (all[i] === v) { pos = ' ' + (i + 1) + ' of ' + all.length; break; }
      }
    }
    return (paused ? 'Play video' : 'Pause video') + pos + ' — ' + what;
  }

  function addButton(v) {
    if (v.hasAttribute(MARK) || hasControl(v)) return;
    v.setAttribute(MARK, '1');

    var host = v.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'elagia-video-pause';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', label(v, false));
    btn.style.cssText =
      'position:absolute;z-index:6;right:12px;bottom:12px;width:44px;height:44px;' +
      'display:inline-flex;align-items:center;justify-content:center;' +
      'border:1px solid rgba(255,255,255,.85);border-radius:50%;' +
      'background:rgba(0,0,0,.55);color:#fff;cursor:pointer;padding:0;' +
      'font:13px/1 system-ui,-apple-system,sans-serif;letter-spacing:.5px';
    btn.textContent = '❚❚';

    function render() {
      var paused = v.paused;
      btn.textContent = paused ? '▶' : '❚❚';
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', label(v, paused));
    }
    btn.addEventListener('click', function () {
      if (v.paused) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
      else v.pause();
      render();
    });
    v.addEventListener('play', render);
    v.addEventListener('pause', render);

    host.appendChild(btn);

    // уважаем системную настройку «меньше движения»
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        v.pause(); v.removeAttribute('autoplay');
      }
    } catch (e) {}
    render();
  }

  function sweep() {
    var vids = document.querySelectorAll('video[autoplay]:not([' + MARK + '])');
    for (var i = 0; i < vids.length; i++) addButton(vids[i]);
  }

  var t = null;
  function schedule() { if (t) return; t = setTimeout(function () { t = null; sweep(); }, 300); }

  function start() {
    sweep();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ───────────────────────────────────────────────────────────────────────────
   Блок v3b — 1.1.1: плейсхолдеры вместо alt.
   На главной три <img> с alt="Image" / "Video alt text" — это постеры видео,
   то есть декоративные. Скринридер зачитывает «Image», что хуже молчания.
   Временная мера: помечаем декоративными. Правильное решение — настоящие
   описания в Theme editor, это делает владелец.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var JUNK = /^(image|video alt text|alt text|product title|placeholder)$/i;
  function sweep() {
    var imgs = document.querySelectorAll('img[alt]');
    for (var i = 0; i < imgs.length; i++) {
      var a = (imgs[i].getAttribute('alt') || '').trim();
      if (a && JUNK.test(a)) imgs[i].setAttribute('alt', '');
    }
  }
  var t = null;
  function schedule() { if (t) return; t = setTimeout(function () { t = null; sweep(); }, 300); }
  function start() {
    sweep();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ── Блок v3c (19.09.2026) — 3.3.1 Error Identification.
   Перекрёстная проверка по чеклисту AccessLint: форма контактов ставит aria-invalid="true"
   и показывает текст ошибки, но не связывает его с полем — скринридер слышит «invalid»,
   а что именно не так, не получает. Связываем через aria-describedby с ближайшим
   видимым сообщением об ошибке. Ничего не рисуем, только семантика.                     ── */
(function () {
  'use strict';
  var n = 0;
  function errorFor(field) {
    var scope = field.closest('.field, .form__field, .form-field, .input-group, label, fieldset, div') || field.parentElement;
    for (var depth = 0; scope && depth < 4; depth++) {
      var cands = scope.querySelectorAll('[class*="error"], [role="alert"], .form__message, .field__message');
      for (var i = 0; i < cands.length; i++) {
        var c = cands[i];
        if (c === field || c.contains(field)) continue;
        if (c.getClientRects().length && (c.textContent || '').trim()) return c;
      }
      scope = scope.parentElement;
    }
    return null;
  }
  function link() {
    var fields = document.querySelectorAll('input[aria-invalid="true"], select[aria-invalid="true"], textarea[aria-invalid="true"]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      var err = errorFor(f); if (!err) continue;
      if (!err.id) err.id = 'elagia-a11y-err-' + (++n);
      var cur = (f.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      if (cur.indexOf(err.id) === -1) { cur.push(err.id); f.setAttribute('aria-describedby', cur.join(' ')); }
    }
  }
  var t = null;
  function schedule() { if (t) return; t = setTimeout(function () { t = null; link(); }, 150); }
  function start() {
    link();
    new MutationObserver(schedule).observe(document.documentElement,
      { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-invalid', 'class', 'hidden'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ───────────────────────────────────────────────────────────────────────────
   Блок v4 (31.10.2026)
   1) 1.3.1/4.1.2: кнопка выбора страны (snippets/country-localization) ссылается
      aria-controls="HeaderCountryList" / aria-describedby="HeaderCountryLabel" на id,
      которых в DOM нет. Список получает этот id, битый describedby снимаем.
   2) 1.3.1 (axe region): нижняя мобильная панель <mobile-navigation-bar> — ссылки
      вне ориентиров. Даём ей role=navigation с именем.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  function fixLocalization() {
    var btns = document.querySelectorAll('.button-localization[aria-controls], .button-localization[aria-describedby]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var ctl = b.getAttribute('aria-controls');
      if (ctl && !document.getElementById(ctl)) {
        var list = b.parentElement && b.parentElement.querySelector('.disclosure__list-wrapper');
        if (list && !list.id) list.id = ctl; else b.removeAttribute('aria-controls');
      }
      var desc = b.getAttribute('aria-describedby');
      if (desc && !document.getElementById(desc)) b.removeAttribute('aria-describedby');
    }
  }
  function fixMobileBar() {
    var bars = document.querySelectorAll('mobile-navigation-bar');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      if (bar.closest('nav,[role="navigation"],footer,header,main,[role="region"]')) continue;
      if (!bar.hasAttribute('role')) bar.setAttribute('role', 'navigation');
      if (!bar.hasAttribute('aria-label')) bar.setAttribute('aria-label', 'Quick links');
    }
  }
  function run() { fixLocalization(); fixMobileBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
